import styles from '../styles/about.module.css';

const About = () => {
  const stats = [
    { number: '95%', label: 'Internship Completion Rate' },
    { number: '100+', label: 'Successful Graduates' },
    { number: '10+', label: 'Industry Partners' },
    { number: '5+', label: 'Technical Domains' },
  ];

  const values = [
    {
      title: 'Industry-Aligned Learning',
      description:
        "Our programs are designed in collaboration with industry experts to ensure you learn skills that matter in today's job market.",
    },
    {
      title: 'Hands-on Experience',
      description:
        'Gain practical experience through real-world projects and internships that simulate actual work environments.',
    },
    {
      title: 'Career Growth',
      description:
        'We focus on both technical skills and professional development to prepare you for long-term career success.',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <h1 className={styles.title}>Bridging Education and Industry</h1>
          <p className={styles.subtitle}>
            Empowering fresh graduates with industry-relevant skills, practical experience, and
            career opportunities through premium internship programs and technical training.
          </p>
        </div>
      </section>

      {/* Stats Grid */}
      <div className={styles.statsGrid}>
        {stats.map((stat, index) => (
          <div key={index} className={styles.statCard}>
            <div className={styles.statNumber}>{stat.number}</div>
            <div className={styles.statLabel}>{stat.label}</div>
          </div>
        ))}
      </div>

      {/* Mission Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Our Mission</h2>
        <p>
          To transform fresh graduates into industry-ready professionals by providing high-quality
          internships, practical training, and mentorship. We bridge the gap between academic
          knowledge and industry requirements, ensuring our participants are well-prepared for
          successful careers in technology.
        </p>
      </section>

      {/* Core Values */}
      <section className={styles.valuesSection}>
        <div className={styles.valuesGrid}>
          <h2 className={styles.valuesTitle}>What Sets Us Apart</h2>
          <div className={styles.valueCards}>
            {values.map((value, index) => (
              <div key={index} className={styles.valueCard}>
                <h3 className={styles.valueCardTitle}>{value.title}</h3>
                <p className={styles.valueCardText}>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Programs Overview */}
      <section className={styles.programsSection}>
        <h2 className={styles.programsTitle}>Our Programs</h2>
        <div className={styles.programCard}>
          <h3 className={styles.programCardTitle}>Technical Internships</h3>
          <p className={styles.programCardText}>
            Gain hands-on experience in cutting-edge technologies through our structured internship
            programs. Work on real projects, learn from industry experts, and earn valuable
            certifications.
          </p>
        </div>
        <div className={styles.programCard}>
          <h3 className={styles.programCardTitle}>Skill Development</h3>
          <p className={styles.programCardText}>
            Access specialized training modules in latest technologies, soft skills workshops, and
            industry knowledge sessions designed to enhance your professional capabilities.
          </p>
        </div>
        <div className={styles.programCard}>
          <h3 className={styles.programCardTitle}>Career Support</h3>
          <p className={styles.programCardText}>
            Benefit from our extensive industry network, placement assistance, and ongoing
            mentorship to kickstart your career in the tech industry.
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;
